
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30861',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30861",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55422",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8405",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11859",
  "I18n": "static-7.1681",
  "quartz": "static-1.7537",
  "quartz-config": "static-1.1315",
  "quartz-core": "static-1.6756",
  "react-dlb": "static-1.90",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.81",
  "reselect": "static-3.13",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.991",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55409",
  "feedback-utils": "static-1.55413",
  "forms-embed-utils-lib": "static-1.4833",
  "forms-utils-lib": "static-1.13177",
  "foundations-assets": "static-1.5257",
  "foundations-components": "static-1.8588",
  "foundations-theming": "static-1.4848",
  "hub-http": "static-1.6579",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12166",
  "icons": "static-2.695",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4164",
  "raven": "static-3.5925",
  "react": "static-7.199",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17095",
  "react-select-plus": "static-1.114",
  "react-utils": "static-2.5596",
  "react-virtualized": "static-2.108",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.509",
  "tinymce-plugins": "static-1.58331",
  "transmute": "static-2.97",
  "ui-images": "static-2.1265",
  "UIComponents": "static-3.8805",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3814",
  "quartz-webpack": "static-1.3761",
  "foundations-theming-specialty": "static-1.2564",
  "property-description-translator": "static-1.4193",
  "HeadJS": "static-2.805",
  "framer-motion": "static-1.80",
  "hs-test-utils-bend-plugin": "static-1.3516",
  "msw": "static-1.39",
  "msw-config": "static-1.9",
  "testing-library": "static-1.160",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.230",
  "moment-timezone": "static-5.92",
  "jasmine": "static-4.4680",
  "jasmine-runner": "static-1.6817",
  "opentelemetry-fe-types": "static-1.154",
  "dispatcher": "static-1.144",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.889",
  "hubspotter-http": "static-1.4899",
  "mobile-manifest-mixins": "static-1.585",
  "module-federation": "static-1.34",
  "opentelemetry-fe": "static-1.529",
  "quartz-auth": "static-1.1212",
  "quartz-head": "static-1.1202",
  "quartz-i18n": "static-1.1212",
  "quartz-routing": "static-1.967",
  "quartz-test": "static-1.1212",
  "quartz-tracking": "static-1.916",
  "trellis-components": "static-1.2840",
  "ui-fonts": "static-1.1121",
  "usage-tracker-container": "static-1-feat-usage-tracker-event-property.48",
  "usage-tracker-core": "static-1-feat-usage-tracker-event-property.48",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.258",
  "conversations-skeleton-state": "static-1.7597",
  "reference-resolvers": "static-1.8551",
  "sanitize-text": "static-1.8526",
  "PatternValidationJS": "static-1.3259",
  "ReduxMessenger": "static-2.10740",
  "outpost": "static-1.4506",
  "rpc-client-utils": "static-1.5035",
  "sanitize": "static-1.4841",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4857",
  "floating-ui": "static-1.64",
  "hs-story-utils": "static-1.9792",
  "react-aria": "static-1.73",
  "react-create-root-preference": "static-1.80",
  "tanstack-table": "static-1.62",
  "trellis-assets": "static-1.2821",
  "bend-plugin-foundations-theming": "static-1.3331",
  "foundations-theming-base": "static-1.3833",
  "stylex": "static-1.42",
  "hs-locale-management": "static-1.335",
  "csstype": "static-1.50",
  "web-vitals": "static-1.16",
  "ai-components-ui-library": "static-1.9843",
  "atom": "static-1.5450",
  "codemirror": "static-5.103",
  "content-assistance-lib": "static-1.8282",
  "ContentUtils": "static-1.69254",
  "data-token-picker": "static-1.16974",
  "file-manager-components": "static-1.24638",
  "FileManagerCore": "static-1.40137",
  "FileManagerLib": "static-1.40278",
  "frontend-preferences-client": "static-1.8290",
  "hub-http-contrib": "static-1.3396",
  "interframe": "static-3.5112",
  "layout-dnd-components": "static-1.13058",
  "layout-dnd-utils": "static-1.12033",
  "property-translator": "static-1.5750",
  "react-codemirror": "static-1.11011",
  "react-colorpicker": "static-2.10583",
  "reference-resolvers-lite": "static-1.8473",
  "rich-text-lib": "static-1.20400",
  "tinymce-data": "static-1.41302",
  "tinymce-themes": "static-1.57187",
  "ui-addon-emoji-picker": "static-1.10239",
  "ui-addon-sales-email": "static-1.5571",
  "ui-brand-identity-lib": "static-1.16689",
  "bender-build-tools": "static-1.3452",
  "opentelemetry-web": "static-1.15",
  "beacon-keepalive-queue": "static-1.74",
  "hub-http-shared-msw-handlers": "static-1.10724",
  "hubspotter-http-shared-msw-handlers": "static-1.10722",
  "usage-tracker-session-replay": "static-1-feat-usage-tracker-event-property.48",
  "base-ui": "static-1.23",
  "react-day-picker": "static-1.11",
  "trellis-theming": "static-1.1345",
  "tanstack-virtual": "static-1.39",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.445",
  "chirp-fetch": "static-1.2266",
  "stylex-utils": "static-1.149",
  "chatspot-core": "static-1.23316",
  "copilot-toolkit": "static-1.11956",
  "customer-data-objects-ui-components": "static-1.13398",
  "data-fetching-client": "static-1.10016",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5128",
  "ui-addon-video-player": "static-1.9052",
  "ui-coaching-tips": "static-1.29420",
  "usage-tracker": "static-1-feat-usage-tracker-event-property.48",
  "cms-field-types": "static-1.5180",
  "content-icons-ui": "static-1.2410",
  "integrations-lib": "static-1.17198",
  "customer-data-objects": "static-1.8059",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1897",
  "apollo-link-hub-http": "static-2.5008",
  "apollo-stack-hubspot": "static-3.95",
  "graphql": "static-1.90",
  "immer": "static-1.102",
  "immerable": "static-1.4513",
  "ui-addon-iframeable": "static-1.9448",
  "video-components-external": "static-1.12255",
  "video-data-lib": "static-1.35913",
  "breeze-artifacts-sdk": "static-1.555",
  "audio-components": "static-1.6431",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29900",
  "FileManagerImages": "static-1.37789",
  "foundations-components-legacy": "static-1.1613",
  "html-to-image": "static-1.62",
  "redux-toolkit": "static-1.79",
  "salesImages": "static-1.630",
  "ui-universal-auth": "static-1.9519",
  "urlinator": "static-1.4886",
  "video-components": "static-1.14257",
  "video-embed": "static-1.36747",
  "ts-schema": "static-1.4333",
  "ContentData": "static-1.69329",
  "layout-data-lib": "static-1.10358",
  "react-dnd-compat": "static-1.4983",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1915",
  "external-options-client-types": "static-1.4380",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7264",
  "hs-promise-utils": "static-1.5959",
  "inbound-db-properties-service-client": "static-1.4083",
  "NamespacedHubStyle": "static-2.9298",
  "growth-onboarding-confetti": "static-1.3433",
  "SharedI18nStrings": "static-1.184",
  "ui-addon-i18n": "static-1.11518",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5808",
  "magpie-types": "static-1.5268",
  "simple-logging-lib": "static-1.3421",
  "avatar-components": "static-1.2853",
  "customer-data-ui-utilities": "static-1.10199",
  "growth-onboarding-feedback-components": "static-1.6955",
  "flux-actions": "static-1.375",
  "hubspot-apollo-client": "static-1.5244",
  "integrations-error-boundary-lib": "static-1.14613",
  "integrations-tracking-lib": "static-1.5980",
  "laboratory-lib": "static-3.7521",
  "native-integrations-shared-strings": "static-1.8135",
  "redux-observable": "static-1.76",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10641",
  "unified-auth": "static-1.1033",
  "breeze-engine-chat-components": "static-1.875",
  "breeze-engine-core": "static-1.1175",
  "ably": "static-2.2",
  "highlight.js": "static-1.87",
  "pulse": "static-1.1001",
  "navigation-messaging": "static-1.8274",
  "content-media-composition-data-lib": "static-1.13382",
  "content-media-compositions": "static-2.17389",
  "idb-keyval": "static-1.52",
  "media-bridge-lib": "static-1.19491",
  "nudge-client-utils": "static-1.3239",
  "unified-auth-core-lib": "static-1.1315",
  "social-insights-client-types": "static-1.22743",
  "advanced-menus-core": "static-1.15661",
  "advanced-menus-lib": "static-1.12507",
  "ExportDialog": "static-6.10748",
  "ui-memberships-settings-lib": "static-1.34953",
  "conditional-properties-service-client": "static-1.4056",
  "crm-pipelines-api-client-types": "static-1.4387",
  "fdsr-migration-layer": "static-1.383",
  "framework-builder-read-service-client": "static-1.4261",
  "framework-data-schema-quick-fetch": "static-1.7169",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3949",
  "persist-promise": "static-1.4072",
  "foundations-components-test-utils": "static-1.6071",
  "reactive-lib": "static-1.1089",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.703",
  "universal-page-editor-lib": "static-1.3380",
  "adobe-sign-auth-lib": "static-1.580",
  "ads-unified-auth-lib": "static-1.1603",
  "custom-vendor-connection-lib": "static-1.83",
  "google-sheets-integration-lib": "static-1.1143",
  "microsoft-drive-auth-lib": "static-1.282",
  "surveymonkey-integration-lib": "static-1.622",
  "slack-ui-library": "static-1.10767",
  "bend-plugin-pulse": "static-1.504",
  "event-emitter": "static-1.1326",
  "fast-json-patch": "static-1.71",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.2996",
  "nudge-renderer-utils": "static-1.3315",
  "onboarding-tours": "static-1.17229",
  "whisper-core-api": "static-1.7445",
  "fsm": "static-1.4122",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15660",
  "simple-menus-lib": "static-1.17177",
  "settings-ui-lib": "static-1.12892",
  "crm-record-cards-service-types": "static-1.3808",
  "location-customization-utils-lib": "static-1.10223",
  "getting-started-shared-tasks": "static-1.19366",
  "growth-data-modal": "static-1.5982",
  "growth-onboarding-next-action-utils": "static-1.2802",
  "navigation-components": "static-1.18947",
  "onboarding-tours-client": "static-1.5444",
  "onboarding-tours-utils": "static-1.1296",
  "ui-shepherd-tracker": "static-1.8022",
  "user-context": "static-1.5471",
  "react-flip-move": "static-1.79",
  "onboarding-data-sync-lib": "static-1.2637",
  "growth-onboarding-next-action-components": "static-1.2830",
  "user-context-client": "static-1.4878",
  "nest": "static-1.604",
  "getting-started-shared-tasks-store": "static-1.18484",
  "InboxConnectUtils": "static-4.15666",
  "meetings-connect-utils-lib": "static-1.7981",
  "onboarding-scopes": "static-1.6822"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30861",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55422",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8405",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11859",
  "I18n": "/I18n/static-7.1681",
  "quartz": "/quartz/static-1.7537",
  "quartz-config": "/quartz-config/static-1.1315",
  "quartz-core": "/quartz-core/static-1.6756",
  "react-dlb": "/react-dlb/static-1.90",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.81",
  "reselect": "/reselect/static-3.13",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.991",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55409",
  "feedback-utils": "/feedback-utils/static-1.55413",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4833",
  "forms-utils-lib": "/forms-utils-lib/static-1.13177",
  "foundations-assets": "/foundations-assets/static-1.5257",
  "foundations-components": "/foundations-components/static-1.8588",
  "foundations-theming": "/foundations-theming/static-1.4848",
  "hub-http": "/hub-http/static-1.6579",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12166",
  "icons": "/icons/static-2.695",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4164",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.199",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17095",
  "react-select-plus": "/react-select-plus/static-1.114",
  "react-utils": "/react-utils/static-2.5596",
  "react-virtualized": "/react-virtualized/static-2.108",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.509",
  "tinymce-plugins": "/tinymce-plugins/static-1.58331",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1265",
  "UIComponents": "/UIComponents/static-3.8805",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3814",
  "quartz-webpack": "/quartz-webpack/static-1.3761",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2564",
  "property-description-translator": "/property-description-translator/static-1.4193",
  "HeadJS": "/HeadJS/static-2.805",
  "framer-motion": "/framer-motion/static-1.80",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3516",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.9",
  "testing-library": "/testing-library/static-1.160",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.230",
  "moment-timezone": "/moment-timezone/static-5.92",
  "jasmine": "/jasmine/static-4.4680",
  "jasmine-runner": "/jasmine-runner/static-1.6817",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.154",
  "dispatcher": "/dispatcher/static-1.144",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.889",
  "hubspotter-http": "/hubspotter-http/static-1.4899",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.585",
  "module-federation": "/module-federation/static-1.34",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.529",
  "quartz-auth": "/quartz-auth/static-1.1212",
  "quartz-head": "/quartz-head/static-1.1202",
  "quartz-i18n": "/quartz-i18n/static-1.1212",
  "quartz-routing": "/quartz-routing/static-1.967",
  "quartz-test": "/quartz-test/static-1.1212",
  "quartz-tracking": "/quartz-tracking/static-1.916",
  "trellis-components": "/trellis-components/static-1.2840",
  "ui-fonts": "/ui-fonts/static-1.1121",
  "usage-tracker-container": "/usage-tracker-container/static-1-feat-usage-tracker-event-property.48",
  "usage-tracker-core": "/usage-tracker-core/static-1-feat-usage-tracker-event-property.48",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.258",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7597",
  "reference-resolvers": "/reference-resolvers/static-1.8551",
  "sanitize-text": "/sanitize-text/static-1.8526",
  "PatternValidationJS": "/PatternValidationJS/static-1.3259",
  "ReduxMessenger": "/ReduxMessenger/static-2.10740",
  "outpost": "/outpost/static-1.4506",
  "rpc-client-utils": "/rpc-client-utils/static-1.5035",
  "sanitize": "/sanitize/static-1.4841",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4857",
  "floating-ui": "/floating-ui/static-1.64",
  "hs-story-utils": "/hs-story-utils/static-1.9792",
  "react-aria": "/react-aria/static-1.73",
  "react-create-root-preference": "/react-create-root-preference/static-1.80",
  "tanstack-table": "/tanstack-table/static-1.62",
  "trellis-assets": "/trellis-assets/static-1.2821",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3331",
  "foundations-theming-base": "/foundations-theming-base/static-1.3833",
  "stylex": "/stylex/static-1.42",
  "hs-locale-management": "/hs-locale-management/static-1.335",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.16",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9843",
  "atom": "/atom/static-1.5450",
  "codemirror": "/codemirror/static-5.103",
  "content-assistance-lib": "/content-assistance-lib/static-1.8282",
  "ContentUtils": "/ContentUtils/static-1.69254",
  "data-token-picker": "/data-token-picker/static-1.16974",
  "file-manager-components": "/file-manager-components/static-1.24638",
  "FileManagerCore": "/FileManagerCore/static-1.40137",
  "FileManagerLib": "/FileManagerLib/static-1.40278",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8290",
  "hub-http-contrib": "/hub-http-contrib/static-1.3396",
  "interframe": "/interframe/static-3.5112",
  "layout-dnd-components": "/layout-dnd-components/static-1.13058",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12033",
  "property-translator": "/property-translator/static-1.5750",
  "react-codemirror": "/react-codemirror/static-1.11011",
  "react-colorpicker": "/react-colorpicker/static-2.10583",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8473",
  "rich-text-lib": "/rich-text-lib/static-1.20400",
  "tinymce-data": "/tinymce-data/static-1.41302",
  "tinymce-themes": "/tinymce-themes/static-1.57187",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10239",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5571",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16689",
  "bender-build-tools": "/bender-build-tools/static-1.3452",
  "opentelemetry-web": "/opentelemetry-web/static-1.15",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.74",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10724",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10722",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-feat-usage-tracker-event-property.48",
  "base-ui": "/base-ui/static-1.23",
  "react-day-picker": "/react-day-picker/static-1.11",
  "trellis-theming": "/trellis-theming/static-1.1345",
  "tanstack-virtual": "/tanstack-virtual/static-1.39",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.445",
  "chirp-fetch": "/chirp-fetch/static-1.2266",
  "stylex-utils": "/stylex-utils/static-1.149",
  "chatspot-core": "/chatspot-core/static-1.23316",
  "copilot-toolkit": "/copilot-toolkit/static-1.11956",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13398",
  "data-fetching-client": "/data-fetching-client/static-1.10016",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5128",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9052",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29420",
  "usage-tracker": "/usage-tracker/static-1-feat-usage-tracker-event-property.48",
  "cms-field-types": "/cms-field-types/static-1.5180",
  "content-icons-ui": "/content-icons-ui/static-1.2410",
  "integrations-lib": "/integrations-lib/static-1.17198",
  "customer-data-objects": "/customer-data-objects/static-1.8059",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1897",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5008",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.95",
  "graphql": "/graphql/static-1.90",
  "immer": "/immer/static-1.102",
  "immerable": "/immerable/static-1.4513",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9448",
  "video-components-external": "/video-components-external/static-1.12255",
  "video-data-lib": "/video-data-lib/static-1.35913",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.555",
  "audio-components": "/audio-components/static-1.6431",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29900",
  "FileManagerImages": "/FileManagerImages/static-1.37789",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1613",
  "html-to-image": "/html-to-image/static-1.62",
  "redux-toolkit": "/redux-toolkit/static-1.79",
  "salesImages": "/salesImages/static-1.630",
  "ui-universal-auth": "/ui-universal-auth/static-1.9519",
  "urlinator": "/urlinator/static-1.4886",
  "video-components": "/video-components/static-1.14257",
  "video-embed": "/video-embed/static-1.36747",
  "ts-schema": "/ts-schema/static-1.4333",
  "ContentData": "/ContentData/static-1.69329",
  "layout-data-lib": "/layout-data-lib/static-1.10358",
  "react-dnd-compat": "/react-dnd-compat/static-1.4983",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1915",
  "external-options-client-types": "/external-options-client-types/static-1.4380",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7264",
  "hs-promise-utils": "/hs-promise-utils/static-1.5959",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4083",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9298",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3433",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.184",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11518",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5808",
  "magpie-types": "/magpie-types/static-1.5268",
  "simple-logging-lib": "/simple-logging-lib/static-1.3421",
  "avatar-components": "/avatar-components/static-1.2853",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10199",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6955",
  "flux-actions": "/flux-actions/static-1.375",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5244",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14613",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5980",
  "laboratory-lib": "/laboratory-lib/static-3.7521",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8135",
  "redux-observable": "/redux-observable/static-1.76",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10641",
  "unified-auth": "/unified-auth/static-1.1033",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.875",
  "breeze-engine-core": "/breeze-engine-core/static-1.1175",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.87",
  "pulse": "/pulse/static-1.1001",
  "navigation-messaging": "/navigation-messaging/static-1.8274",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13382",
  "content-media-compositions": "/content-media-compositions/static-2.17389",
  "idb-keyval": "/idb-keyval/static-1.52",
  "media-bridge-lib": "/media-bridge-lib/static-1.19491",
  "nudge-client-utils": "/nudge-client-utils/static-1.3239",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1315",
  "social-insights-client-types": "/social-insights-client-types/static-1.22743",
  "advanced-menus-core": "/advanced-menus-core/static-1.15661",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12507",
  "ExportDialog": "/ExportDialog/static-6.10748",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34953",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4056",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4387",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.383",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4261",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7169",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3949",
  "persist-promise": "/persist-promise/static-1.4072",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6071",
  "reactive-lib": "/reactive-lib/static-1.1089",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.703",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3380",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.580",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1603",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.83",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1143",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.282",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.622",
  "slack-ui-library": "/slack-ui-library/static-1.10767",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.504",
  "event-emitter": "/event-emitter/static-1.1326",
  "fast-json-patch": "/fast-json-patch/static-1.71",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2996",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3315",
  "onboarding-tours": "/onboarding-tours/static-1.17229",
  "whisper-core-api": "/whisper-core-api/static-1.7445",
  "fsm": "/fsm/static-1.4122",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15660",
  "simple-menus-lib": "/simple-menus-lib/static-1.17177",
  "settings-ui-lib": "/settings-ui-lib/static-1.12892",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3808",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10223",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19366",
  "growth-data-modal": "/growth-data-modal/static-1.5982",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2802",
  "navigation-components": "/navigation-components/static-1.18947",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5444",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1296",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8022",
  "user-context": "/user-context/static-1.5471",
  "react-flip-move": "/react-flip-move/static-1.79",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2637",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2830",
  "user-context-client": "/user-context-client/static-1.4878",
  "nest": "/nest/static-1.604",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18484",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15666",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7981",
  "onboarding-scopes": "/onboarding-scopes/static-1.6822"
}
};
